import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungGera() {
  return (
    <CityPageTemplate
      city="Gera"
      slug="gera"
      intro="Gera als zweitgrößte Stadt Thüringens – nutze staatliche Förderungen und smarte Geldanlage für Deine Zukunft."
      description="Unabhängige & digitale Finanzberatung für Gera: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
